import { Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import React from 'react'
import { NavLink } from 'react-router-dom';

const tagsList = [
    {
        "title": "Allen Solly",
        "url": "/card-details/808/-allen-solly-e-gift-card",
    },
    {
        "title": "Louis PhilippeS",
        "url": "/card-details/706/louis-philippe-e-gift-cards"
    },
    {
        "title": "Peter England",
        "url": "/card-details/704/peter-england-e-gift-card"
    },
    {
        "title": "Van Heusen",
        "url": "/card-details/705/van-heusen-e-gift-cards"
    },
    {
        "title": "Levis",
        "url": "/card-details/95/levis-e-gift-card-qc"
    },
    {
        "title": "US Polo Assn",
        "url": "/card-details/87/us-polo-assn-e-gift-card-brand-voucher"
    },
    {
        "title": "FLYING MACHINE",
        "url": "/card-details/89/flying-machine-e-gift-card-brand-voucher"
    },
    {
        "title": "Vero Moda",
        "url": "/card-details/212/vero-moda-e-gift-card-brand-voucher"
    },
    {
        "title": "JACK & JONES",
        "url": "/card-details/241/jack--jones-e-gift-card-brand-voucher"
    },
    {
        "title": "ONLY",
        "url": "/card-details/257/only-e-gift-card-brand-voucher"
    },
    {
        "title": "Bata",
        "url": "/card-details/713/batatx-e-gift-voucher"
    },
    {
        "title": "Woodland",
        "url": "/card-details/492/woodland-e-gift-card"
    },
    {
        "title": "Puma",
        "url": "/card-details/498/puma-e-voucher"
    },
    {
        "title": "Skechers",
        "url": "/card-details/243/skechers-e-gift-card-qc-brand-voucher"
    },
    {
        "title": "Relaxo",
        "url": "/card-details/493/relaxo-e-gift-card"
    },
    {
        "title": "Hush Puppies",
        "url": "/card-details/869/hush-puppies-e-gift-cardtx"
    },
    {
        "title": "Amazon Pay Gift ",
        "url": "/card-details/914/amazon-pay-gift-voucher"
    },
    {
        "title": "Flipkart",
        "url": "/card-details/112/flipkart-e-gift-card-brand-voucher"
    },
    {
        "title": "Myntra",
        "url": "/card-details/484/myntra-e-gift-card"
    },
    {
        "title": "AJIO",
        "url": "/card-details/455/ajio-e-gift-card"
    },
    {
        "title": "Nykaa",
        "url": "/card-details/188/nykaa-e-gift-card-brand-voucher"
    },
    {
        "title": "TATA CliQ",
        "url": "/card-details/859/tata-cliq-e-gift-instant-voucher"
    },
    {
        "title": "FirstCry",
        "url": "/card-details/135/firstcry-e-gift-card-brand-voucher"
    },
    {
        "title": "Fastrack",
        "url": "/card-details/106/fastrack-e-gift-card-brand-voucher"
    },
    {
        "title": "The Body Shop",
        "url": "/card-details/128/the-body-shop-e-gift-card-brand-voucher"
    },
    {
        "title": "Ray-Ban",
        "url": "/card-details/252/ray-ban-e-gift-card-brand-voucher"
    },
    {
        "title": "Titan Eye Plus",
        "url": "/card-details/465/titan-eye-plus-e-gift-cards"
    },
    {
        "title": "Samsonite",
        "url": "/card-details/557/samsonite-e-gift-card"
    },
    {
        "title": "American Tourister",
        "url": "/card-details/564/american-tourister-e-gift-card"
    },
    {
        "title": "Decathlon",
        "url": "/card-details/591/decathlon---egift-card"
    },
    {
        "title": "Lenskart",
        "url": "/card-details/972/lenskart-e-gift-cards"
    },
    {
        "title": "PVR INOX Cinemas",
        "url": "/card-details/218/pvr-inox-cinemas-e-gift-card-brand-voucher"
    },
    {
        "title": "Google Play",
        "url": "/card-details/485/google-play-e-gift-card"
    },
    {
        "title": "Steam",
        "url": "/card-details/695/steam-e-gift-voucher"
    },
    {
        "title": "UniPin",
        "url": "/card-details/711/unipin-e-gift-card"
    },
    {
        "title": "Cinepolis",
        "url": "/card-details/943/cinepolis-e-gift-card"
    },
    {
        "title": "PlayStation (Sony)",
        "url": "/card-details/964/playstation-gift-vouchers-sony"
    },
    {
        "title": "Book My Show",
        "url": "/card-details/974/book-my-show-e-gift-cards"
    },
    {
        "title": "Dominos",
        "url": "/card-details/1067/dominos-e-gift-card"
    },
    {
        "title": "Starbucks",
        "url": "/card-details/627/starbucks-e-gift-voucher"
    },
    {
        "title": "Blinkit",
        "url": "/card-details/999/blinkit-e-gift-card"
    },
    {
        "title": "Max Fashion",
        "url": "/card-details/803/max-fashion-gift-voucher"
    },
    {
        "title": "Lifestyle (Store Only)",
        "url": "/card-details/449/lifestyle-e-gift-card-store-only"
    },
    {
        "title": "Pantaloons",
        "url": "/card-details/457/pantaloons-e-gift-card-brand-voucher"
    },
    {
        "title": "Shoppers Stop",
        "url": "/card-details/688/shoppers-stop-e-gift-card-tx"
    },
    {
        "title": "TRENDS (Reliance)",
        "url": "/card-details/461/trends-reliance-e-gift-card"
    },
    {
        "title": "Westside",
        "url": "/card-details/944/westside-e-gift-vouchers-brand-vouchers"
    },
    {
        "title": "Zomato",
        "url": "/card-details/693/zomato-gift-voucher"
    },
    {
        "title": "Swiggy Money ",
        "url": "/card-details/558/swiggy-money-e-voucher"
    },
    {
        "title": "McDonalds",
        "url": "/card-details/649/mcdonalds-e-gift-card"
    },
    {
        "title": "Cafe Coffee Day",
        "url": "/card-details/167/cafe-coffee-day-e-gift-card-brand-voucher"
    },
    {
        "title": "BARBEQUE NATION",
        "url": "/card-details/102/barbeque-nation-e-gift-card-brand-voucher"
    },
    {
        "title": "Subway",
        "url": "/card-details/832/subway-e-gift-card"
    },
    {
        "title": "Amazon Shopping",
        "url": "/card-details/860/amazon-shopping-gift-voucher"
    },
    {
        "title": "Nykaa Fashion",
        "url": "/card-details/644/nykaa-fashion-e-gift-card"
    },
    {
        "title": "Croma",
        "url": "/card-details/488/croma-e-gift-card-brand-voucher"
    },
    {
        "title": "Reliance Digital",
        "url": "/card-details/489/reliance-digital-e-gift-voucher-brand-voucher"
    },
    {
        "title": "Amazon Prime Membership",
        "url": "/card-details/576/amazon-prime-voucher-12-months-membership"
    },
    {
        "title": "Make My Trip (Generic)",
        "url": "/card-details/818/make-my-trip-e-gift-card-generic"
    },
    {
        "title": "Cleartrip",
        "url": "/card-details/814/cleartrip-e-gift-card"
    }
];

const BrandTag = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "center",

                width: "100%",
                mb: 2,
                px: 2,
                py: 1,
                backgroundColor: "primaryaDark.main",
            }}
        >
            <Typography
                component={'span'}
                sx={{
                    color: "secondary.main",
                    fontWeight: "600",
                    textTransform: "capitalize",
                    fontSize: "16px"
                }}
            >
                Brands&nbsp;:
            </Typography>

            <List
                sx={{
                    color: "white.main",
                    display: "inline-flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    py: 0,
                }}
            >
                {tagsList.map((tag, index) => (
                    <React.Fragment key={`tag_${index * 1}`}>
                        <ListItem
                            sx={{
                                display: "inline-block",
                                width: "auto",
                                px: "3px",
                                py: "2px",
                            }}>
                            <NavLink to={tag?.url}>
                                <ListItemText
                                    primary={`${tag.title?.toLowerCase()} ${tagsList?.length - 1 !== index ? '|' : ''}`}
                                    sx={{
                                        display: "inline-block",
                                        color: "white.main",
                                        fontWeight: 400,
                                        textTransform: "capitalize",
                                        fontSize: 14,
                                        '&:hover': {
                                            color: "secondary.main",
                                            textDecoration: "underline",
                                        }
                                    }}
                                />
                            </NavLink>
                        </ListItem>
                    </React.Fragment>
                ))}
            </List>

        </Box>
    )
}

export default BrandTag
